import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { ContentTemplate, Progress, SectionHeader, TitleHeader } from 'web-library';
import { useGetExamLevelsAndResourceTypes } from '../../../api-refactored/onlineTutorials/useGetExamLevelsAndResourceTypes';
import { useGetResource } from '../../../api-refactored/onlineTutorials/useGetResource';
import ResourceFormDataView from '../../../modules/usefulInformation/components/ResourceFormDataView';

interface ResourceParams {
  uuid: string;
}

const EditResource = () => {
  const { t } = useTranslation();

  const [isSuccess, setIsSucess] = useState<boolean>(false);
  const [isSuccessResource, setIsSucessResource] = useState<boolean>(false);
  const { uuid } = useParams<ResourceParams>();

  const { data: resourceData } = useGetResource({
    uuid,
    onSuccess: () => {
      setIsSucessResource(true);
    },
  });

  const { data } = useGetExamLevelsAndResourceTypes({
    onSuccess: () => {
      setIsSucess(true);
    },
  });

  return (
    <>
      <TitleHeader title={t('usefulInformation->>Listing.UsefulInformation')} />
      <ContentTemplate>
        <SectionHeader title={t('usefulInformation->>Listing.EditResource')} />
        {isSuccess && isSuccessResource ? (
          <ResourceFormDataView
            isEditMode
            examLevelData={data?.examLevels || []}
            resourceTypeData={data?.resourceTypes || []}
            resourceData={resourceData}
          />
        ) : (
          <Progress color="secondary" />
        )}
      </ContentTemplate>
    </>
  );
};

export default EditResource;
